<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/browser-not-support/error.svg"
                alt="browsernotsupport"
                class="mx-auto browser-error"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">{{$t('BROWSER_NOT_SUPPORTED').Title}}</h4>
                </div>

                <div>
                  <div>{{$t('BROWSER_NOT_SUPPORTED').Text}}</div>
                  <div class="apps">
                    <div class="other-browsers">
                      <div class="fs-12 mb-5 no-wrap">{{$t('BROWSER_NOT_SUPPORTED').Other_Browsers}}</div>
                      <div class="browsers-imgs">
                        <img
                          @click="openBrowser('chrome')"
                          src="@/assets/images/pages/browser-not-support/chrome.svg"
                          alt="chrome"
                        />
                        <img
                          @click="openBrowser('firefox')"
                          src="@/assets/images/pages/browser-not-support/firefox.svg"
                          alt="firefox"
                        />
                        <img
                          @click="openBrowser('safari')"
                          src="@/assets/images/pages/browser-not-support/safari.svg"
                          alt="safari"
                        />
                      </div>
                    </div>
                    <div class="windows-store">
                      <div class="fs-12 mb-5 no-wrap">{{$t('BROWSER_NOT_SUPPORTED').TitleWindows_Store}}</div>
                      <img
                        src="@/assets/images/pages/browser-not-support/windows-store.png"
                        alt="safari"
                      />
                    </div>
                  </div>

                  <!-- <div class="flex flex-wrap justify-between my-5"></div>
                  <div class="flex flex-row-reverse"></div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {};
  },
  methods: {
    openBrowser(browser) {
      // try {
      //   var shell = new ActiveXObject("WScript.Shell");
      //   shell.run(`${browser} ${config.web_url}`);
      // } catch (error) {
      //   console.log(error);
      // }
    }
  }
};
</script>

<style lang="scss">
#page-login {
  .browser-error {
    width: 150px;
  }
  h4 {
    color: #d96055;
    font-weight: bold;
    font-size: 20px;
  }
  .apps {
    display: flex;
    width: 100%;
    margin-top: 10px;
  }
  .other-browsers {
    width: 300px;
  }
  .browsers-imgs {
    display: flex;
  }
  .no-wrap {
    white-space: nowrap;
  }
}

.apps {
  img {
    width: 40px;
    margin-right: 17px;
    cursor: pointer;
  }
  .fs-12 {
    font-size: 12px;
  }
  .mb-5 {
    margin-bottom: 5px;
  }
}
</style>
